import React from "react";
import { HiOutlineBars3 } from "react-icons/hi2";
import { IoMoonSharp, IoNotifications } from "react-icons/io5";
import { useAuth } from "../context/auth-context";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import NotificationModal from "./NotificationModal";
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "../context/user-context";
import { RiSunFill } from "react-icons/ri";

const Navbar = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { setIsOpen, isNotified, setIsNotified, theme, setTheme } = useUser();
  const axiosInstance = useAuthAxios();

  const fetchUserData = async () => {
    try {
        const response = await axiosInstance.get(API.getUser);
      return response.data;
    } catch (error: any) {
      // Surface a clean error for react-query so it can retry/show error states
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "No response received from server";
      throw new Error(message);
    }
  };
  const { data: userData }: any = useQuery({
    queryKey: ["userProfile"],
    queryFn: fetchUserData,
    enabled: isAuthenticated,
  });

  const firstInitial = userData?.data.user.profile.firstName || "";
  const secondInitial = userData?.data.user.profile.lastName || "";

  // Fetch unread notifications count
  const fetchUnreadNotifications = async () => {
    const response = await axiosInstance.get(API.getNotifications(1));
    return response.data;
  };

  const { data: notificationsData } = useQuery({
    queryKey: ["unreadNotifications"],
    queryFn: fetchUnreadNotifications,
    enabled: isAuthenticated,
  });

  const unreadNotify =
    notificationsData?.data.meta.noOfUnreadInAppNotifications || 0;

  return (
    <div className="w-full">
      <div className="flex justify-between font-manrope items-center bg-white dark:bg-[#0D0D0D] lgss:pt-4 pt-4  lgss:w-full pb-4 dark:mb-0  px-5 dark:pb-4 lgss:px-10">
        <div className="flex justify-center items-center gap-4 lgss:gap-2 ">
          <HiOutlineBars3
            className=" text-black dark:text-[white] cursor-pointer lgss:hidden text-[32px]"
            onClick={() => setIsOpen((prev: any) => !prev)}
          />
          <div className="w-[14px] h-[5px] bg-secondary_button hidden lgss:flex rounded-lg" />
          <h4 className="font-sora text-black dark:text-white">
            {location.pathname === "/dashboard"
              ? "Dashboard"
              : location.pathname === "/wallet"
              ? "Wallet"
              : location.pathname === "/trade"
              ? "Trade"
              : location.pathname === "/activity"
              ? "Activity"
              : location.pathname === "/settings"
              ? "Settings"
              : location.pathname === "/cards"
              ? "Cards"
              : null}
          </h4>
        </div>
        <div className="flex   justify-center  items-center gap-2 lgss:gap-4">
          <div className="flex gap-4  justify-center items-center ">
            <div className="relative">
              <IoNotifications
                onClick={() => setIsNotified((prev: any) => !prev)}
                className="text-2xl lgss:text-3xl text-black dark:text-white cursor-pointer"
              />
              {unreadNotify >= 1 && (
                <div className="bell-light absolute top-0 animate-pulse -right-[1px] w-2 h-2 bg-secondary_button rounded-full" />
              )}
            </div>
            <Link
              to="/settings"
              state={{ screen: 1 }}
              className="rounded-full w-[42px] h-[42px] bg-[#D4EBFD] flex items-center justify-center font-medium dark:font-bold text-secondary_button cursor-pointer"
            >
              {firstInitial.charAt(0).toUpperCase()}
              {secondInitial.charAt(0).toUpperCase()}
            </Link>
            {theme === "dark" ? (
              <RiSunFill
                onClick={() => setTheme("light")}
                className="text-[24px] text-[#FFEB33] cursor-pointer"
              />
            ) : (
              <IoMoonSharp
                onClick={() => setTheme("dark")}
                className="text-[24px] text-black cursor-pointer"
              />
            )}
          </div>
        </div>
      </div>
      {isNotified && <NotificationModal setIsNotified={setIsNotified} />}
    </div>
  );
};

export default Navbar;
